
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"3.422 3.389 91 91"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticStyle:{"paint-order":"stroke","fill":"none","stroke":"currentColor","stroke-width":"6"},attrs:{"cx":"49.068","cy":"48.725","r":"41.001"}}),_c('path',{staticStyle:{"fill":"currentColor","white-space":"pre"},attrs:{"d":"M 45.733 54.711 C 45.733 52.938 46.003 51.431 46.543 50.191 C 47.083 48.958 47.733 47.948 48.493 47.161 C 49.246 46.374 50.233 45.518 51.453 44.591 C 52.36 43.884 53.08 43.274 53.613 42.761 C 54.14 42.248 54.58 41.654 54.933 40.981 C 55.286 40.301 55.463 39.518 55.463 38.631 C 55.463 37.038 54.913 35.828 53.813 35.001 C 52.713 34.174 51.17 33.761 49.183 33.761 C 46.903 33.761 45.176 34.348 44.003 35.521 C 42.836 36.688 42.263 38.384 42.283 40.611 L 35.823 40.611 C 35.823 37.898 36.386 35.568 37.513 33.621 C 38.646 31.674 40.23 30.194 42.263 29.181 C 44.303 28.168 46.65 27.661 49.303 27.661 C 51.663 27.661 53.786 28.054 55.673 28.841 C 57.56 29.628 59.06 30.851 60.173 32.511 C 61.286 34.171 61.843 36.261 61.843 38.781 C 61.843 40.528 61.58 42.011 61.053 43.231 C 60.533 44.451 59.9 45.441 59.153 46.201 C 58.406 46.954 57.433 47.784 56.233 48.691 C 55.253 49.438 54.483 50.081 53.923 50.621 C 53.356 51.161 52.886 51.811 52.513 52.571 C 52.14 53.331 51.953 54.221 51.953 55.241 L 51.953 56.981 L 45.733 56.981 L 45.733 54.711 Z M 45.023 69.371 L 45.023 61.611 L 52.873 61.611 L 52.873 69.371 L 45.023 69.371 Z"}})])
          )
        }
      }
    